<ng-container *ngIf="currentViewState">
    <ng-container ntapFilterViewProvider [viewName]="currentViewName" [viewState]="currentViewStateFilter" #filter>
        <ng-container appOdabirPovezanogMjestaProvider [viewName]="currentViewName" [viewState]="currentViewState">
            <ntap-view-window target="globalDialog"></ntap-view-window>
            <ntap-dynamic [compId]="INIT_COMP_ID" [class]="currentViewClass"></ntap-dynamic>
            <p-button styleClass="mt-3" ntapDebounceClick [disabled]="(disabled$ | async) ?? true" label="Odaberite" (onClick)="selectItem()" />
        </ng-container>
    </ng-container>
  </ng-container>